import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "info-page-content wiki-page" }
const _hoisted_2 = { class: "addon-overview" }
const _hoisted_3 = { class: "addon-rules" }
const _hoisted_4 = { class: "wiki-panel addon-limits" }
const _hoisted_5 = { class: "addon-scenarios" }
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "cards-in-game" }
const _hoisted_8 = { class: "player-count" }
const _hoisted_9 = { class: "card-grid" }
const _hoisted_10 = { class: "card-item-small" }
const _hoisted_11 = { class: "card-item-small" }
const _hoisted_12 = { class: "card-item-small" }
const _hoisted_13 = { class: "player-count" }
const _hoisted_14 = { class: "card-grid" }
const _hoisted_15 = { class: "card-item-small" }
const _hoisted_16 = { class: "card-item-small" }
const _hoisted_17 = { class: "card-item-small" }
const _hoisted_18 = { class: "card-item-small" }
const _hoisted_19 = { class: "card-list" }
const _hoisted_20 = { class: "card-item" }
const _hoisted_21 = { class: "card-header" }
const _hoisted_22 = { class: "card-item" }
const _hoisted_23 = { class: "card-header" }
const _hoisted_24 = { class: "card-item" }
const _hoisted_25 = { class: "card-header" }
const _hoisted_26 = { class: "card-item" }
const _hoisted_27 = { class: "card-header" }
const _hoisted_28 = { class: "card-list" }
const _hoisted_29 = { class: "card-item" }
const _hoisted_30 = { class: "card-header" }
const _hoisted_31 = { class: "card-item" }
const _hoisted_32 = { class: "card-header" }
const _hoisted_33 = { class: "card-item" }
const _hoisted_34 = { class: "card-header" }
const _hoisted_35 = { class: "card-item" }
const _hoisted_36 = { class: "card-header" }
const _hoisted_37 = { class: "card-list" }
const _hoisted_38 = { class: "card-item" }
const _hoisted_39 = { class: "card-header" }

import WikiBreadCrumbs from '@/components/header/WikiBreadCrumbs.vue';
import SchemaImage from '@/components/view/SchemaImage.vue';
import LocalizedTextWrapper from '@/components/feedback/LocalizedTextWrapper.vue';
import WikiPlayCta from '@/components/view/information/WikiPlayCta.vue';
import PlotCard from '@/components/view/information/PlotCard.vue';
import { getImagePathByID } from '@/helpers/images';

export default /*@__PURE__*/_defineComponent({
  __name: 'PlotCards',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_LocaleLink = _resolveComponent("LocaleLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WikiBreadCrumbs),
    _createElementVNode("h1", null, _toDisplayString(_ctx.$t('plotCards.seoHeading')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(SchemaImage, {
        class: "addon-image",
        src: _unref(getImagePathByID)('features', 'plot_cards'),
        alt: _ctx.$t('addons.plotCards'),
        description: _ctx.$t('addons.plotCards')
      }, null, 8, ["src", "alt", "description"]),
      _createElementVNode("p", null, [
        _createVNode(LocalizedTextWrapper, { keypath: "plotCards.seoIntro" })
      ])
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('wiki.rules')), 1),
      _createElementVNode("ol", null, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (number) => {
          return _createElementVNode("li", { key: number }, [
            _createVNode(LocalizedTextWrapper, {
              keypath: `plotCards.seoRule${number}`
            }, null, 8, ["keypath"])
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('wiki.roleLimit')), 1),
      _createElementVNode("p", null, [
        _createVNode(LocalizedTextWrapper, { keypath: "plotCards.seoLimit1" })
      ]),
      _createElementVNode("p", null, [
        _createVNode(LocalizedTextWrapper, { keypath: "plotCards.seoLimit2" })
      ])
    ]),
    _createElementVNode("section", _hoisted_5, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('wiki.roleScenarios')), 1),
      _createElementVNode("ul", null, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (number) => {
          return _createElementVNode("li", { key: number }, [
            _createVNode(LocalizedTextWrapper, {
              keypath: `plotCards.seoScenario${number}`
            }, null, 8, ["keypath"])
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("nav", {
      class: "wiki-nav",
      "aria-label": _ctx.$t('wiki.title')
    }, [
      _createVNode(_component_LocaleLink, { to: { name: 'expansions' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('wiki.addonsTitle')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_LocaleLink, { to: { name: 'roles' } }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('wiki.rolesTitle')), 1)
        ]),
        _: 1
      })
    ], 8, _hoisted_6),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('plotCards.cardsInGame')), 1),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('plotCards.fiveToSixPlayers')), 1),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
            return _createElementVNode("div", {
              class: "card-item-small",
              key: 'leadToVictory' + i
            }, [
              _createVNode(PlotCard, {
                class: "card-icon-small",
                cardName: "leadToVictory",
                displayTooltip: true
              })
            ])
          }), 64)),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
            return _createElementVNode("div", {
              class: "card-item-small",
              key: 'ambush' + i
            }, [
              _createVNode(PlotCard, {
                class: "card-icon-small",
                cardName: "ambush",
                displayTooltip: true
              })
            ])
          }), 64)),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(PlotCard, {
              class: "card-icon-small",
              cardName: "kingReturns",
              displayTooltip: true
            })
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(PlotCard, {
              class: "card-icon-small",
              cardName: "restoreHonor",
              displayTooltip: true
            })
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(PlotCard, {
              class: "card-icon-small",
              cardName: "charge",
              displayTooltip: true
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t('plotCards.sevenPlusPlayers')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('plotCards.additionalCards')), 1),
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
            return _createElementVNode("div", {
              class: "card-item-small",
              key: 'kingReturns' + i
            }, [
              _createVNode(PlotCard, {
                class: "card-icon-small",
                cardName: "kingReturns",
                displayTooltip: true
              })
            ])
          }), 64)),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(PlotCard, {
              class: "card-icon-small",
              cardName: "charge",
              displayTooltip: true
            })
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(PlotCard, {
              class: "card-icon-small",
              cardName: "showNature",
              displayTooltip: true
            })
          ]),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (i) => {
            return _createElementVNode("div", {
              class: "card-item-small",
              key: 'areYouTheOne' + i
            }, [
              _createVNode(PlotCard, {
                class: "card-icon-small",
                cardName: "areYouTheOne",
                displayTooltip: true
              })
            ])
          }), 64)),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(PlotCard, {
              class: "card-icon-small",
              cardName: "weFoundYou",
              displayTooltip: true
            })
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createVNode(PlotCard, {
              class: "card-icon-small",
              cardName: "showStrength",
              displayTooltip: true
            })
          ])
        ])
      ])
    ]),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('plotCards.cardTypes')), 1),
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('plotCards.usableCards')), 1),
    _createElementVNode("ul", _hoisted_19, [
      _createElementVNode("li", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(PlotCard, {
            class: "card-icon",
            cardName: "leadToVictory"
          }),
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('cardsInfo.leadToVictory')), 1)
        ]),
        _createVNode(LocalizedTextWrapper, { keypath: "plotCards.leadToVictoryDesc" })
      ]),
      _createElementVNode("li", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createVNode(PlotCard, {
            class: "card-icon",
            cardName: "ambush"
          }),
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('cardsInfo.ambush')), 1)
        ]),
        _createVNode(LocalizedTextWrapper, { keypath: "plotCards.ambushDesc" })
      ]),
      _createElementVNode("li", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createVNode(PlotCard, {
            class: "card-icon",
            cardName: "kingReturns"
          }),
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('cardsInfo.kingReturns')), 1)
        ]),
        _createVNode(LocalizedTextWrapper, { keypath: "plotCards.kingReturnsDesc" })
      ]),
      _createElementVNode("li", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(PlotCard, {
            class: "card-icon",
            cardName: "weFoundYou"
          }),
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('cardsInfo.weFoundYou')), 1)
        ]),
        _createVNode(LocalizedTextWrapper, { keypath: "plotCards.weFoundYouDesc" })
      ])
    ]),
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('plotCards.instantCards')), 1),
    _createElementVNode("ul", _hoisted_28, [
      _createElementVNode("li", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(PlotCard, {
            class: "card-icon",
            cardName: "restoreHonor"
          }),
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('cardsInfo.restoreHonor')), 1)
        ]),
        _createVNode(LocalizedTextWrapper, { keypath: "plotCards.restoreHonorDesc" })
      ]),
      _createElementVNode("li", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createVNode(PlotCard, {
            class: "card-icon",
            cardName: "showStrength"
          }),
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('cardsInfo.showStrength')), 1)
        ]),
        _createVNode(LocalizedTextWrapper, { keypath: "plotCards.showStrengthDesc" })
      ]),
      _createElementVNode("li", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createVNode(PlotCard, {
            class: "card-icon",
            cardName: "showNature"
          }),
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('cardsInfo.showNature')), 1)
        ]),
        _createVNode(LocalizedTextWrapper, { keypath: "plotCards.showNatureDesc" })
      ]),
      _createElementVNode("li", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createVNode(PlotCard, {
            class: "card-icon",
            cardName: "areYouTheOne"
          }),
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('cardsInfo.areYouTheOne')), 1)
        ]),
        _createVNode(LocalizedTextWrapper, { keypath: "plotCards.areYouTheOneDesc" })
      ])
    ]),
    _createElementVNode("h3", null, _toDisplayString(_ctx.$t('plotCards.effectsCards')), 1),
    _createElementVNode("ul", _hoisted_37, [
      _createElementVNode("li", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createVNode(PlotCard, {
            class: "card-icon",
            cardName: "charge"
          }),
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t('cardsInfo.charge')), 1)
        ]),
        _createVNode(LocalizedTextWrapper, { keypath: "plotCards.chargeDesc" })
      ])
    ]),
    _createVNode(WikiPlayCta)
  ]))
}
}

})